var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSoundLight && _vm.showAlarmGif)?_c('img',{staticStyle:{"display":"block","width":"100%","height":"auto"},attrs:{"src":require("@/assets/alarm/alert.gif")}}):_vm._e(),_c('audio',{ref:"audio",attrs:{"muted":""},on:{"ended":_vm.onPlayEnd}},[_vm._v(" Your browser does not support the audio element. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }